import React from 'react';

import Slot from '../../Slot';
import InTransitInvoicesByStatusChart from '../../Charts/InTransitInvoicesByStatusChart';
import './styles.css';

class InTransitInvoicesByStatus extends React.Component {
  render() {
    const {
      onTime,
      lateOneDay,
      lateTwoDays,
      lateThreeDays,
      forToday,
      theme,
    } = this.props;

    return (
      <div className="TwoLinesContent__root">
        <div className="TwoLinesContent__flex__row">
          <Slot
            empty
          >
            <div className="TwoColsContent__Flex__col">
              <div className="TwoLinesContent__flex__row">
                {onTime && <Slot
                  className='Slot__value__success'
                  label="No prazo"
                  value={onTime.percentage}
                  small={`(${onTime.percentage}%)`}
                  separator
                  verticalSeparator
                />}
                {lateOneDay && <Slot
                  className='Slot__value__warning'
                  label="Atrasado + 1 dia"
                  value={lateOneDay.percentage}
                  small={`(${lateOneDay.percentage}%)`}
                  separator
                  verticalSeparator
                />}
              </div>
              <div className="TwoLinesContent__flex__row">
                {lateTwoDays && <Slot
                  className='Slot__value__calm'
                  theme={theme}
                  label="Atrasado +2 dias"
                  value={lateTwoDays.percentage}
                  small={`(${lateTwoDays.percentage}%)`}
                  verticalSeparator
                />}
                {lateThreeDays && <Slot
                  className='Slot__value__blue'
                  theme={theme}
                  label="Atrasado + 3 dias"
                  value={lateThreeDays.percentage}
                  small={`(${lateThreeDays.percentage}%)`}
                  verticalSeparator
                />}
              </div>
            </div>
          </Slot>
          <InTransitInvoicesByStatusChart
            lateThreeDays={lateThreeDays.percentage}
            lateTwoDays={lateTwoDays.percentage}
            lateOneDay={lateOneDay.percentage}
            onTime={onTime.percentage}
            forToday={forToday}
          />
        </div>
      </div>
    );
  }
}

export default InTransitInvoicesByStatus;
